import React, { useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import Select from "components/select";

const SECOND_IN_MILLIS = 1000;
export const DEFAULT_INTERVAL = 30 * SECOND_IN_MILLIS;
const AVAILABLE_INTERVALS = [1, 5, 30];

const IntervalSelect = ({ intervalsInSeconds = AVAILABLE_INTERVALS, value, onChange, ...props }) => {
  const availableIntervals = intervalsInSeconds.map(interval => ({
    label: interval,
    value: interval * SECOND_IN_MILLIS,
  }));

  useEffect(
    () => {
      if (!value) {
        onChange(DEFAULT_INTERVAL);
      }
    },
    [onChange, value],
  );

  const handleChangeInterval = useCallback(({ target: { value } }) => onChange(value), [onChange]);

  return (
    <Select
      id="interval"
      name="interval"
      getValueFromElement={e => e.value}
      getLabelFromElement={e => e.label}
      elements={availableIntervals}
      value={value}
      onChange={handleChangeInterval}
      {...props}
    />
  );
};

IntervalSelect.propTypes = {
  /**
   * Texto de la etiqueta
   **/
  label: PropTypes.string,
  /**
   * Valor a representar
   **/
  value: PropTypes.number,
  /**
   * Array de intervalos a representar (en segundos)
   **/
  intervalsInSeconds: PropTypes.array,
  /**
   * Callback de cambio
   **/
  onChange: PropTypes.func,
};

export default IntervalSelect;
